<ng-container *ngIf="revisionStatuses$ | async as revisionStatuses">
  <div class="page-content">
    <div class="grid h-100" style="grid-template-rows: auto 1fr">
      <div class="g-col-6 g-col-xl-8 ms-auto order-2">
        <button (click)="onNew()" type="button" class="btn btn-dark">
          {{ 'admin.pools.revision_status.actions.new' | translate }}
        </button>
      </div>
      <div class="g-col-6 g-col-xl-4 order-1">
        <man-search-input
          [shortcutActive]="true"
          placeholder="admin.pools.revision_status.filter.placeholder"
          [disabled]="revisionStatuses.requestState !== 'success'"
          (search)="onSearch($event)"
          (clear)="onSearchClear()"
        >
        </man-search-input>
      </div>
      <man-table-wrapper class="g-col-12 order-3" [request]="revisionStatuses">
        <p-table
          name="RevisionStatus"
          selectionMode="single"
          [globalFilterFields]="filterFields"
          [value]="revisionStatuses.data | copyArray"
          [loading]="revisionStatuses.requestState === 'loading'"
          [scrollable]="true"
          scrollHeight="flex"
          [sortField]="sortBy"
          (onRowReorder)="onReorder($event)"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="p-col-fixed p-col--icon"></th>
              <th>
                {{ 'admin.pools.revision_status.table.position' | translate }}
              </th>
              <th>
                {{ 'admin.pools.revision_status.table.short_name' | translate }}
              </th>
              <th>
                {{
                  'admin.pools.revision_status.table.description' | translate
                }}
              </th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-revisionStatus let-index="rowIndex">
            <tr
              interactiveRow
              (edit)="onEdit(revisionStatus)"
              (delete)="onDelete(revisionStatus)"
              [pReorderableRow]="index"
            >
              <td [ngClass]="{ 'disabled-cursor': inSearchMode }">
                <i
                  aria-hidden="true"
                  class="fa-regular fa-bars"
                  [title]="'common.messages.drag_and_drop' | translate"
                  [pReorderableRowHandle]="index"
                ></i>
              </td>
              <td>{{ revisionStatus.position + 1 }}</td>
              <td>{{ revisionStatus.shortName }}</td>
              <td>{{ revisionStatus.description }}</td>
              <td class="text-end">
                <man-action-menu
                  [data]="revisionStatus"
                  [options]="menuOptions"
                ></man-action-menu>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center">
                {{
                  'admin.pools.revision_status.table.messages.empty' | translate
                }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </man-table-wrapper>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="formState$ | async as formState">
  <man-side-panel
    *ngIf="formState.show"
    [title]="
      (formState.data
        ? 'admin.pools.revision_status.table.form.title.edit'
        : 'admin.pools.revision_status.table.form.title.create'
      ) | translate
    "
    [closeable]="true"
    (closed)="revisionStatusForm.onClose()"
  >
    <man-revision-status-form
      #revisionStatusForm
      class="mx-n3"
      [disabled]="formState.disabled"
      [revisionStatus]="formState.data"
      (create)="onCreate($event)"
      (update)="onUpdate($event)"
      (closed)="onDismiss()"
    >
    </man-revision-status-form>
  </man-side-panel>
</ng-container>
